<template>
  <tr>
    <td style="width: 16px;">
      <q-icon name="drag_indicator" color="grey-7" class="drag-item-handle" />
    </td>
    <td class="text-left">{{ lineItem.itemName }}</td>
    <td class="text-right text-no-wrap">{{ quantityFormatted }}</td>
    <td class="text-right text-no-wrap">{{ priceFormatted }}</td>
    <td v-if="showDiscount" class="text-right text-no-wrap">{{ discountString }}</td>
    <td class="text-right text-no-wrap">{{ salesTaxFormatted }}</td>
    <td class="text-right text-no-wrap">{{ sumFormatted }}</td>
    <td class="text-right text-no-wrap">
      <q-btn icon="edit" color="grey-6" flat dense @click="handleEdit" />
      <q-btn icon="delete" color="grey-6" class="q-ml-sm" flat dense @click="handleDelete" />
    </td>
  </tr>
</template>

<script>
  import { formatMoney, formatNumber } from 'src/utils/format'
  import Decimal from 'decimal.js'

  function numberToDecimal (number) {
    if (typeof number === 'string') {
      number = number.replace(/,/, '.')
    }

    return new Decimal(number)
  }

  export default {
    props: {
      lineItem: {
        type: Object,
        required: true
      },
      showDiscount: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      quantityFormatted () {
        return formatNumber(this.lineItem.quantity)
      },
      price () {
        return new Decimal(this.lineItem.price)
      },
      priceFormatted () {
        return formatMoney(this.price.toNumber())
      },
      sum () {
        let itemNet = null

        if (this.lineItem.price !== null && this.lineItem.quantity !== null) {
          let itemPrice = numberToDecimal(this.lineItem.price)
          let itemQuantity = numberToDecimal(this.lineItem.quantity)
          itemNet = itemPrice.times(itemQuantity)
        } else {
          itemNet = 0
        }

        if (this.lineItem.discountRelative) {
          const discount = numberToDecimal(this.lineItem.discountRelative)
          const value = new Decimal(1).minus(discount.dividedBy(100))
          itemNet = itemNet.times(value)
        }

        if (this.lineItem.discountAbsolute) {
          const discount = numberToDecimal(this.lineItem.discountAbsolute)
          itemNet = itemNet.minus(discount)
        }

        return itemNet
      },
      sumFormatted () {
        return formatMoney(this.sum.toNumber())
      },
      salesTaxFormatted () {
        return `${this.lineItem.salesTax} %`
      },
      hasDiscount () {
        return this.lineItem.discountAbsolute || this.lineItem.discountRelative
      },
      discountString () {
        if (!this.hasDiscount) {
          return ''
        }

        if (this.lineItem.discountAbsolute) {
          return formatMoney(this.lineItem.discountAbsolute)
        } else {
          return this.lineItem.discountRelative + '%'
        }
      }
    },
    methods: {
      handleEdit () {
        this.$emit('update')
      },
      handleDelete () {
        this.$emit('remove')
      }
    }
  }
</script>
